import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FormError } from '../../interfaces';
import { useIntl } from '../../providers';

interface StyleProps {
    hasError: boolean;
}

const useStyles = createUseStyles({
    fieldWrap: {
        display: 'flex',
        flexDirection: 'column',
        '& input, & select': {
            transition: '.1s ease-in-out',
            transitionProperty: 'color, background-color',
            color: ({ hasError }: StyleProps) => (hasError ? 'red' : 'currentColor'),
            border: '0',
            borderBottom: ({ hasError }: StyleProps) => `2px solid ${hasError ? 'red' : 'var(--primary-color)'}`,
            padding: '.3rem .6rem',
        },
        '& label': {
            marginBottom: 0,
        },
        '& + $fieldWrap': {
            marginTop: '1rem',
        },
    },
    errorLabel: {
        color: 'red',
    },
    optional: {
        color: '#999999',
    },
});

interface FieldWrapProps {
    children: React.ReactElement | React.ReactElement[];
    label?: string;
    required?: boolean;
    error?: FormError;
}

const FieldWrap: React.FC<FieldWrapProps> = ({ children, label = '', error, required = true }: FieldWrapProps) => {
    const classes = useStyles({ hasError: !!error });
    const { translate } = useIntl();

    return (
        <div className={classes.fieldWrap}>
            {(label || error) && (
                <label>
                    {label} {!required && !error && <span className={classes.optional}>(optional)</span>}
                    {(error?.type === 'required' || error?.message) && (
                        <span className={classes.errorLabel}>
                            ({error.type === 'required' ? translate('orderForm.required', 'required') : error.message})
                        </span>
                    )}
                    {required && '*'}
                </label>
            )}
            {children}
        </div>
    );
};

export default React.memo(FieldWrap);
